import { Fragment, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Dialog } from "@headlessui/react";
import { WrapperChatSender, TextChatSender } from "components/moleculs/Chats";
import { Field, Form, Formik } from "formik";

const LiveChat = ({ passLiveChatRefs, footerChatRefs, setCurrentState }) => {
    const [open, setOpen] = useState(false);
    const fieldRef = useRef(null);

    useImperativeHandle(passLiveChatRefs, () => ({
        openModal() {
            openLiveChat();
        },
        closeModal() {
            closeLiveChat();
        },
        open
    }));

    useImperativeHandle(footerChatRefs, () => ({
        openModal() {
            openFooterChat();
        },
        closeModal() {
            closeFooterChat();
        },
    }));

    const openLiveChat = () => {
        setCurrentState(true);
        setOpen(true);
    };

    const closeLiveChat = () => {
        setCurrentState(false);
        setOpen(false);
    };

    const openFooterChat = () => {
        setCurrentState(true);
        setOpen(true);
    };
    const closeFooterChat = () => {
        setCurrentState(false);
        setOpen(false);
    };
    return (
        <Fragment>
            {open ? (
                <Dialog
                    open={true}
                    onClose={() => setOpen(false)}
                    className="relative z-50"
                >
                    <div className="fixed inset-0">
                        <Dialog.Panel className="w-fit fixed phone:max-w-[340px] max-w-[364px] bg-neutral-10 phone:py-4 py-6 z-[99999999] rounded-lg bottom-[96px] right-8 phone:right-4 phone:bottom-[96px]">
                            <div className="flex items-center space-x-4 px-6 phone:px-4">
                                <img src="/images/universal/arrow-left.svg" className="phone:w-5 phone:h-5 w-6 h-6" alt="arrow-left" />
                                <div className="flex items-center space-x-3 relative">
                                    <img src="/images/universal/chat-avatar.svg" className="w-10 h-10" alt="chat-avatar" />
                                    <svg className="w-[16px] h-[16px] absolute bottom-0 left-[18px]" alt="online" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7.5" r="6" fill="#37C99E" stroke="white" strokeWidth="2" />
                                    </svg>
                                    <div className="flex flex-col justify-between gap-2">
                                        <h3 className="text-md font-semibold text-neutral-100 leading-[20px] tracking-text-sm">Anonymous Proxies</h3>
                                        <p className="text-xs font-normal text-neutral-50 leading-[15px] tracking-text">Online</p>
                                    </div>
                                </div>
                            </div>
                            <div className="border-t border-neutral-30 w-full relative mt-5 mb-6"></div>
                            <div className="overflow-auto max-h-[310px] scrollbar-hide mb-6 px-6 phone:px-4">
                                <div className="mb-10">
                                    <div className="flex items-start space-x-3">
                                        <img src="/images/universal/chat-avatar.svg" className="w-10 h-10" alt="chat-avatar" />
                                        <WrapperChatSender>
                                            <TextChatSender>Welcome Anonymous Proxies! You can ask a question, leave a comment, or view a demo here.</TextChatSender>
                                        </WrapperChatSender>
                                    </div>
                                    <div className="flex items-start space-x-3 mt-2">
                                        <div className="w-8 h-8"></div>
                                        <WrapperChatSender>
                                            <TextChatSender>Which would you like to do?</TextChatSender>
                                        </WrapperChatSender>
                                    </div>
                                </div>
                                <div className="flex flex-col items-end gap-2 pb-16 pr-[24px]">
                                    <div className="w-fit bg-primary-surface rounded-xl py-2 px-4">
                                        <h3 className="font-semibold text-xs leading-[20.4px] tracking-text-sm text-primary-main">I have a question</h3>
                                    </div>
                                    <div className="w-fit bg-primary-main rounded-xl py-2 px-4">
                                        <h3 className="font-semibold text-xs leading-[20.4px] tracking-text-sm text-neutral-10">I have a connection problem</h3>
                                    </div>
                                    <div className="w-fit bg-primary-surface rounded-xl py-2 px-4">
                                        <h3 className="font-semibold text-xs leading-[20.4px] tracking-text-sm text-primary-main">Just browsing</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="border-t border-neutral-30 w-full relative mb-4"></div>
                            <Formik>
                                <Form className="w-full flex items-center justify-between gap-2 px-6 phone:px-4">
                                    <Field type="text" placeholder="Write a message..." className="w-full h-[48px] leading-[20.4px] px-4 border-none bg-neutral-20 text-xs rounded-lg font-medium tracking-text-sm text-neutral-60" />
                                    <img src="/images/universal/send-message.svg" className="w-[48px] h-[48px]" alt="send" />
                                </Form>
                            </Formik>
                        </Dialog.Panel>
                    </div>
                </Dialog>
            ) : ""}
        </Fragment>
    );
};

export default LiveChat;